// ============================================================
// THIS WEEK'S TRENDING PICKS
// ------------------------------------------------------------
// Edit this list to change the rotating strip on the Home page.
// To swap in new picks each week, just update the items below:
//   - image : a direct image URL (right-click an image > Copy image address)
//   - name  : the product name in English (en) and Spanish (es)
//   - tag   : the small category label in English (en) and Spanish (es)
// Add or remove items freely — the strip adjusts automatically.
// ============================================================

export const trendingPicks = [
  {
    image: 'https://images.unsplash.com/photo-1560769629-975ec94e6a86?q=80&w=800',
    name: { en: 'Trending Sneakers', es: 'Zapatillas de Moda' },
    tag: { en: 'Footwear', es: 'Calzado' }
  },
  {
    image: 'https://images.unsplash.com/photo-1595341888016-a392ef81b7de?q=80&w=800',
    name: { en: 'Nike Air Max', es: 'Nike Air Max' },
    tag: { en: 'Sneakers', es: 'Zapatillas' }
  },
  {
    image: 'https://images.unsplash.com/photo-1546868871-7041f2a55e12?q=80&w=800',
    name: { en: 'Smart Watch', es: 'Reloj Inteligente' },
    tag: { en: 'Electronics', es: 'Electrónica' }
  },
  {
    image: 'https://images.unsplash.com/photo-1579586337278-3befd40fd17a?q=80&w=800',
    name: { en: 'Fitness Watch', es: 'Reloj Deportivo' },
    tag: { en: 'Wearable', es: 'Portátil' }
  },
  {
    image: 'https://images.unsplash.com/photo-1582616698198-f978da534162?q=80&w=800',
    name: { en: 'Beauty & Perfume', es: 'Belleza y Perfume' },
    tag: { en: 'Beauty', es: 'Belleza' }
  },
  {
    image: 'https://images.unsplash.com/photo-1676570092589-a6c09ecbb373?q=80&w=800',
    name: { en: 'Makeup Sets', es: 'Sets de Maquillaje' },
    tag: { en: 'Cosmetics', es: 'Cosméticos' }
  },
  {
    image: 'https://images.unsplash.com/photo-1705909237050-7a7625b47fac?q=80&w=800',
    name: { en: 'Designer Bag', es: 'Bolso de Diseño' },
    tag: { en: 'Handbags', es: 'Bolsos' }
  },
  {
    image: 'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?q=80&w=800',
    name: { en: 'Luxury Purse', es: 'Cartera de Lujo' },
    tag: { en: 'Accessories', es: 'Accesorios' }
  }
];

export default trendingPicks;
